import api from '../api'

const state = {
  all: [],
  user: null
}

const actions = {
  getUsers: ({ state, commit }) => {
    return api.getAllUsers().then(invoices => {
      return commit('setAllUsers', invoices)
    })
  },
  getUser: ({ state, commit }, id) => {
    return api.getSingleUser(id).then(user => {
      return commit('setSingleUser', user)
    })
  },
  updateUser: ({ state, commit }, update) => {
    return api.updateSingleUser(update).then(user => {
      return commit('setSingleUser', user)
    })
  },
  deleteUser: ({ state, commit }, id) => {
    return api.deleteSingleUser(id).then(() => {
      return commit('setSingleUser', null)
    })
  },
  resetUser: ({ state, commit }, id) => {
    return api.resetUserPassword(id).then(() => {
      return commit('setSingleUser', null)
    })
  },
  addUser: ({ state, commit }, data) => {
    return api.addSingleUser(data).then(() => {
      return commit('setSingleUser', null)
    })
  }
}

const mutations = {
  setAllUsers (state, invoices) {
    state.all = invoices
  },
  setSingleUser (state, user) {
    state.user = user
  }
}

const getters = {
  all: state => {
    return state.all
  },
  user: state => {
    return state.user
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/users.js